define('SC.HorizonThemeExtension.ErrorManagement.PageNotFound.View', [
  'underscore',
  'SC.HorizonThemeExtension.Common.Configuration',
  'SC.HorizonThemeExtension.Common.LayoutHelper'
], function ThemeExtensionErrorManagementPageNotFoundView(
  _,
  Configuration,
  LayoutHelper
) {
  'use strict';

  return {
    loadModule: function loadModule() {
      LayoutHelper.addToViewContextDefinition(
        'ErrorManagement.PageNotFound.View',
        'extraErrorMgtPageNotFoundView',
        'object',
        function () {
          return {
            backgroundImage: _.getAbsoluteUrl(
              Configuration.get(
                'errorManagementPageNotFound.pageNotFoundBgrImg'
              )
            ),
            backgroundColor: Configuration.get(
              'errorManagementPageNotFound.bkgdColor'
            ),
            title: Configuration.get('errorManagementPageNotFound.title'),
            text: Configuration.get('errorManagementPageNotFound.text'),
            btnText: Configuration.get('errorManagementPageNotFound.btnText'),
            btnHref: Configuration.get('errorManagementPageNotFound.btnHref')
          };
        }
      );
    }
  };
});
